import React from 'react';
import { permissionObj } from '../../../../Helpers/permission';
import HeadTittle from '../../../../components/HeadTittle';
import {AddIcon, TrashOutlineIcon} from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import MainReaderTable from "./SubComponents/MainReaderTable";
import ReaderApp from "./Functionality/ReaderApp";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const Readers = () => {

    const {
        DEV,
        permission,
        deleteReaderShow,
        setDeleteReaderShow,
        readerModalShow,
        setReaderModalShow,
        selectedList,
        setSelectedList
    } = ReaderApp();

    return (
        <>
            <HeadTittle name={'readers'}>
                {(DEV || permission?.includes(permissionObj?.WEB_HID_CREATE) ) &&
                    <ButtonAction
                        id='btn_rd_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={()=>{
                            setReaderModalShow(true);
                        }}
                    />
                }
                {(DEV || permission?.includes(permissionObj?.WEB_HID_DELETE) ) &&
                    <ButtonAction
                        id='btn_rd_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={()=>{
                            setDeleteReaderShow(true);
                        }}
                    />
                }
            </HeadTittle>
            <MainReaderTable
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                deleteReaderShow={deleteReaderShow}
                setDeleteReaderShow={setDeleteReaderShow}
                readerModalShow={readerModalShow}
                setReaderModalShow={setReaderModalShow}
            />
        </>
    );
};

export default Readers;
